import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@piximind/ds-p-23/lib/main.css'
import './Style/main.scss'
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
